import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractUserRelatedDataService } from '@y42/feature';
import { VisualizationWidgetQuery, VisualizationWidgetState, VisualizationWidgetStore } from '../../state/widget';

@Injectable({ providedIn: 'root' })
export class VisualizationWidgetUserDataService extends AbstractUserRelatedDataService<VisualizationWidgetState> {
  constructor(
    readonly http: HttpClient,
    readonly store: VisualizationWidgetStore,
    readonly query: VisualizationWidgetQuery,
  ) {
    super({
      http,
      store,
      query,
      URLs: {
        last_used: 'visualization-widget-last_used',
        starred: 'visualization-widget-starred',
      },
    });
  }
}
